import get from '../api/get';

/**
 * @typedef {Object} CustomersQueryOptions
 * @property {import('../../../app-stats/types').CustomerStatus} status
 */

/**
 *
 * @param {CustomersQueryOptions} [options]
 * @returns {import('../../../app-stats/types').Customer[]} customers
 */
export default function getCustomers({ status } = {}) {
    if (status) {
        return get(`/api/v1/customers?status=${status}`);
    }
    return get('/api/v1/customers');
}
